import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AuthService } from '@app/@services';
import { MenuItemModel } from '@app/@shared/models';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-shared-menu-item',
  templateUrl: './shared-menu-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SharedMenuItemComponent implements OnInit {
  @Input()
  item: MenuItemModel;

  constructor(private authService: AuthService, public readonly transloco: TranslocoService) { }

  ngOnInit(): void { }

  /**
   * Paylaşımlı menü de özel durumlar için bu methodu kullanıyoruz.
   * @param item
   */
  onEvent(item: MenuItemModel): void {

    // özel durumlar için böyle bi yöntem kullanıyoruz.
    switch (item.event) {

      // paylaşımlı menüden çıkış yapılmak istenildiğinde localstorage sıfırlayıp yönlendiriyoruz. Şuan için dışa yönlendirme yaptığımız için logoutExternalUrl methodunu kullanıyoruz proje angulara geçildiğinde sadece logout kalacaktır.
      case 'logout':
        this.authService.logout();
        break;
    }
  }
}
